module.exports = __webpack_public_path__ + "img/accompagnements.639e4ea0.svg";